// extracted by mini-css-extract-plugin
export default {"button":"BackLink_button__9KChA","iconWrapper":"BackLink_iconWrapper__ho6g+","icon":"BackLink_icon__lqIin","text":"BackLink_text__V8VbQ"};